import { ChevronLeft, ChevronRight, Search } from 'lucide-react';
import React from 'react';
import ReactImageGallery from 'react-image-gallery';
import { array, string } from 'prop-types';

import ResponsiveImage from '../../../components/ResponsiveImage/ResponsiveImage';
import { FormattedMessage } from '../../../util/reactIntl';

import './image-gallery.css';
import css from './CommunitySection.module.css';

const MAX_MOBILE_SCREEN_WIDTH = 1024;

const CommunitySection = props => {
  const { sectionId, sectionData, reviewData, listingData } = props;
  const titleText = (sectionData && sectionData[0]?.title?.content) || '';
  const descriptionText = (sectionData && sectionData[0]?.description?.content) || '';
  let blocks = (sectionData && sectionData[0]?.blocks) || [];
  // const reviews = (reviewData && reviewData[0]?.blocks) || [];
  // const listings = (listingData && listingData[0]?.blocks) || [];

  const getVariantNames = img => {
    const { variants } = img?.attributes || {};
    return variants ? Object.keys(variants) : [];
  };

  const renderLeftNav = (onClick, disabled) => {
    return (
      <div className={css.leftNav} onClick={onClick} disabled={disabled}>
        <ChevronLeft />
      </div>
    );
  };

  const renderRightNav = (onClick, disabled) => {
    return (
      <div className={css.rightNav} onClick={onClick} disabled={disabled}>
        <ChevronRight />
      </div>
    );
  };

  const renderItem = item => {
    return (
      <div className={css.imageWrapper}>
        <a href={item.image.callToAction.href}>
          <ResponsiveImage
            rootClassName={css.image}
            image={item.image.media.image}
            alt={item.image.media.alt}
            variants={getVariantNames(item.image.media.image)}
          />
          <div className={css.imageOverlay}></div>
        </a>
      </div>
    );
  };

  const items = blocks ? blocks.map((block, i) => {
    return {
      // We will only use the image resource, but react-image-gallery
      // requires the `original` key from each item.
      original: '',
      image: block,
      index: i,
    };
  }) : [];

  const hasMatchMedia = typeof window !== 'undefined' && window?.matchMedia;
  const isMobileLayout = hasMatchMedia
    ? window.matchMedia(`(max-width: ${MAX_MOBILE_SCREEN_WIDTH}px)`)?.matches
    : true;

  return (
    <section id={sectionId} className={css.container}>
      <div className={css.wrapper}>
        <div className={css.text}>
          <div className={css.left}>
            <div>
              <h1 className={css.heading}>{titleText}</h1>
            </div>
          </div>
          <div className={css.right}>
            <p className={css.description}>{descriptionText}</p>
          </div>
        </div>
        <div className={css.imageContainer}>
          <div className="communityRIG">
            {isMobileLayout ? <ReactImageGallery
              infinite={true}
              items={items}
              showBullets={isMobileLayout}
              showPlayButton={false}
              showFullscreenButton={false}
              showIndex={false}
              showNav={!isMobileLayout}
              showThumbnails={false}
              renderItem={renderItem}
              renderLeftNav={renderLeftNav}
              renderRightNav={renderRightNav}
            /> : <div className={css.desktopImageWrapper}>
              {items.map((item, index) => (
                <div key={index} className={css.imageWrapper}>
                  <ResponsiveImage
                    rootClassName={css.image}
                    image={item.image.media.image}
                    alt={item.image.media.alt}
                    variants={getVariantNames(item.image.media.image)}
                  />
                  <div className={css.imageOverlay}></div>
                </div>
              ))}
            </div>}
          </div>
        </div>
        <a href={sectionData[0]?.callToAction?.href}>
          {sectionData[0]?.callToAction?.content}
          <Search />
        </a>
      </div>
    </section>
  );
};

CommunitySection.defaultProps = {
  sectionData: {},
};

CommunitySection.propTypes = {
  sectionId: string.isRequired,
  sectionData: array,
};

export default CommunitySection;
